import { useContext } from "react";

import { IRunContext, RunContext } from "./RunContext";

export function useRun(): IRunContext {
  const context = useContext(RunContext);
  if (!context) {
    throw new Error("useRun must be used within a RunProvider");
  }

  return context;
}
